<template>
  <div class="main-content" :style="mainContentViewHeight">
    <pm-form-config></pm-form-config>
  </div>
</template>

<script>
export default {
  props: ["mainContentViewHeight"],
  data(){
    return {
    };
  },
  components: {
  },
  mounted() {

  },
  methods: {},
};
</script>
